import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const Navbar = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  return (
    <div className="navbar bg-base-100">
      <div className="max-w-7xl mx-auto w-full px-4">
        <div className="flex-1">
          <Link to="/" className="flex items-center gap-3">
            <img src="/assets/logo.svg" alt="Logo" className="w-8 md:w-10" />
            <span className="text-xl md:text-2xl font-bold">Logo Best</span>
          </Link>
        </div>
        <div className="flex-none">
          {isHomePage && (
            <Link to="/create" className="btn btn-primary">
              Create Logo
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default Navbar
